export enum ACTIVITY_CHANGE {
  Added = "added",
  Removed = "removed",
  Changed = "changed",
}

export type ActivityChangeType = "added" | "removed" | "changed";
